module.exports = __webpack_public_path__ + "media/profile-dark.c9c4d858.mp4";